import React, { Component } from 'react'
import injectStyles from 'react-jss'
import UserWidget from './UserWidget'

const styles = {
  controlBar: {
    backgroundColor: '#f3f3f4',
    height: 90,
    lineHeight: '90px',
    textAlign: 'center',
  },
  userWidget: {
    verticalAlign: 'middle',
    float: 'right',
    marginTop: 28,
    marginRight: 54,
  },
}

const ControlBar = ({ classes, children }) => <div className={classes.controlBar}>
  {children}
  <UserWidget className={classes.userWidget} />
</div>

export default injectStyles(styles)(ControlBar)


// WEBPACK FOOTER //
// ./src/modules/ControlBar/ControlBar.js